import React from 'react';
import classNames from 'classnames';
import styles from './image-loader.scss';

type Props = {
  className?: string;
  type?: string;
  withOverlay?: boolean;
};

const ImageLoader = ({ className, type, withOverlay }: Props) => {
  const Loader = () => (
    <div className={classNames(styles.loader, className, 'image-loader', type && styles[type])} />
  );
  return withOverlay ? (
    <div className={styles.loaderOverlay}>
      <Loader />
    </div>
  ) : (
    <Loader />
  );
};

export default ImageLoader;
